import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';

import css from './RadiusFilter.module.css';

const RadiusFilter = props => {
  const {
    label,
    queryParamNames,
    initialValues,
    onSubmit,
    min = 1,
    max = 100,
    step = 1,
    getAriaLabel,
  } = props;

  return (
    <FinalForm
      initialValues={initialValues}
      onSubmit={values => onSubmit(values)}
      render={({ handleSubmit, values }) => (
        <form onChange={handleSubmit} className={css.root}>
          <label className={css.label}>{label}</label>

          <Field name={queryParamNames[0]}>
            {({ input }) => (
              <>
                <input
                  {...input}
                  type="range"
                  min={min}
                  max={max}
                  step={step}
                  aria-label={getAriaLabel(label, input.value)}
                />
                <div className={css.value}>
                  {input.value || min} km
                </div>
              </>
            )}
          </Field>
        </form>
      )}
    />
  );
};

export default RadiusFilter;
